import { AssetManagement } from "@/components/sections/investment/AssetManagement"

export function AssetManagementPage() {
  return <AssetManagement />
} 